import MainLayout from "../../components/layout/MainLayout";
import { Outlet, Navigate } from "react-router-dom";
import { isPublicLogout, restoreAuthSession } from "../../utils/restoreAuthSession";
import InactivityGuard from "./InactivityGuard";

const PrivateRoute = ({ children }: any) => {
  const isLoggedIn = restoreAuthSession();

  if (!isLoggedIn && window.location.pathname !== "/") {
    if (isPublicLogout()) {
      return <Navigate to="/" replace />;
    }
    const redirect = `${window.location.pathname}${window.location.search}`;
    return (
      <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} />
    );
  }
  return (
    <MainLayout>
      <InactivityGuard />
      {children ?? <Outlet />}
    </MainLayout>
  );
};

export default PrivateRoute;
